/**
 * Klevu theme
 * -----------------------------------------------------------------------------
 * Theming file for Klevu search.
 *
 */

/**
 * Create user options object.
 */
if (!window.klevu_uc_userOptions) {
  window.klevu_uc_userOptions = {};
}

/**
  * Set the sort preference value to default (RELEVANCE) on page refresh or navigation
  */
localStorage.setItem('klv_sort_productList', 'RELEVANCE');

/**
 * Set filter position.
 */
window.klevu_uc_userOptions.landingFilterPosition = 'left';
window._klvReady = window._klvReady || [];

/**
 * Retrieve in-grid and meta banner settings from metafields
 */
const inGridBannerSettings = window.theme.collection.metafields || {};
const metaBannerSettings = window.theme.collection.metaAssets || {};
const excludedProductTag = window.theme.strings.excludedProductTag || '';

/**
 * Function to get the meta asset based on the provided key.
 * @param {string} key - The key to search for in the metaBannerSettings.
 * @returns {string|null} - The URL of the asset if found, otherwise null.
 */
function getMetaAsset(key) {
  const asset = metaBannerSettings[key];

  if (asset && (key === 'bannerDesktopVideo' || key === 'bannerMobileVideo')) {
    try {
      const parsedAsset = JSON.parse(asset);

      if (parsedAsset && parsedAsset.sources && parsedAsset.sources[0] && parsedAsset.sources[0].url) {
        return parsedAsset.sources[0].url; // Extract the URL from the sources array
      }

    } catch (e) {
      console.error("Error parsing asset:", e);
    }
  }

  return asset || null;
}

/**
 * Push functionality when Klevu is ready.
 */
window._klvReady.push(function() {

  /**
   * Set settings.
   */
  window.klevu.interactive(function() {
    klevu({
      powerUp: {
        catnav: false,
        landing: false,
      },
      theme: {
        landing: {
          loadDefaultStyles: false,
        },
        catnav: {
          loadDefaultStyles: false,
        },
        modules: {
          resultInfiniteScroll: {
            searchResultsPage: {
              enable: true,
            },
            categoryPage: {
              enable: true,
            },
          },
        },
      },
    });
  });

  /**
   * Modify request to increase items per page.
   */
  var productsPerPage = window.theme?.collection?.productsPerPage || 24
  klevu.modifyRequest('all', 'productList.settings.limit', productsPerPage);
  
    /**
   * Modify request to exclude products with the tag 'hide-search-klevu'
   */
    if(excludedProductTag!== '') {
      klevu.modifyRequest("landing,quick", function (data, scope) {
        klevu.each(data.request.current.recordQueries, function (key, query) {
          klevu.setObjectPath(query, "settings.groupCondition", {
            groupOperator: "ANY_OF",
            conditions: [
              {
                key: "tags",
                valueOperator: "EXCLUDE",
                singleSelect: false,
                values: [excludedProductTag]
              }
            ]
          });
        });
      });
    }

  /**
   * Modify request to set restore behaviour.
   */
  klevu.modifyRequest('catnav,landing', function(data, scope) {
    klevu.each(data.request.current.recordQueries, function(key, query) {
      klevu.setObjectPath(query, 'filters.filtersToReturn.options.limit', 100);

      // No results limit
      const queryID = klevu.getObjectPath(query, 'id');

      if (queryID === 'noResultsFoundPopularProductList') {
        klevu.setObjectPath(query, 'settings.limit', 10);
      }
    });

    // Restore Search Params On Page Load
    klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(data, scope);

    // set the global scope
    window.klevuCurrentScope = scope.kScope;
  });

  /**
   * Modify response to load in grid banner.
   */
  klevu.modifyResponse('catnav', function(data, scope) {
    const type = getMetaAsset('bannerMediaType');
    const title = inGridBannerSettings.find((field) => field[0] === 'banner_title')?.[1] || '';
    const ctaLabel = inGridBannerSettings.find((field) => field[0] === 'klevu_banner_cta_label')?.[1];
    const subtitle = inGridBannerSettings.find((field) => field[0] === 'banner_description')?.[1] || '';
    const ctaUrl = inGridBannerSettings.find((field) => field[0] === 'klevu_banner_cta_url')?.[1];
    const desktopImageHeight= inGridBannerSettings.find((field) => field[0] === 'klevu_banner_d_image_height')?.[1] || 'small';

    /**
     * Default image and video URLs.
     */
    const defaultImage = 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-lifestyle-1_large.png';
    const defaultVideo = 'https://cdn.shopify.com/videos/c/o/v/39147cc0c3764973a3c2ae6318b6125e.mp4';

    /**
     * Use metaAssets or default URLs.
     */
    const src = type === 'video'
      ? (getMetaAsset('bannerDesktopVideo') || defaultVideo)
      : (getMetaAsset('bannerDesktopImg') || defaultImage);

    const mobSrc = type === 'video'
      ? (getMetaAsset('bannerMobileVideo') || defaultVideo)
      : (getMetaAsset('bannerMobileImg') || defaultImage);

    /**
     * Determine if in-grid banner should be rendered.
     */
    window.renderInGridBanner = true;
    window.renderKlevuBanner = true;
    var meta = klevu.getObjectPath(data.template.query, 'productList.meta', false);

    /**
     * Determine if there are active filters.
     */
    var activeFilters = data.template.query?.productList?.filters?.some((filter) => {
      if (filter.key === 'klevu_price') {
        var start = Number(filter.start);
        var end = Number(filter.end);

        var min = Number(filter.min);
        var max = Number(filter.max);

        // End is 0 on page load
        if (end === 0) {
          var end = max;
        }

        return end < max || start > min;
      }

      return filter.options?.some((option) => {
        return option.selected;
      });
    })

    /**
     * Determine product count.
     */
    var productCount = data.template.query?.productList?.result?.length;
    var minProducts = window.theme.klevuAltSettings.minProducts || 18;

    /**
     * Only render when active and correct offset.
     * - Don't render when filters are active and if not enough products.
     */
    if (
      !meta ||
      activeFilters ||
      productCount < minProducts
    ) {
      window.renderInGridBanner = false;
      return;
    }

    /**
     * Additional metafield in-grid banner conditions.
     */
    if (
      !window.theme.klevuAltSettings?.metaTriggeredBanner ||
      (type !== 'image' && type !== 'video') ||
      !src
    ) {
      return;
    }

    /**
     * Push metafield banner into product list.
     */
    data.template.query.productList.result.splice(16, 0, {
      ctaLabel,
      ctaUrl,
      desktopImageHeight,
      mobSrc,
      src,
      subtitle,
      title,
      type,
      typeOfRecord: 'IN_GRID_BANNER',
    });

    window.renderKlevuBanner = false;
  });

  /**
   * Open filter drawer.
   */
  function openFilterDrawer() {
    document.body.classList?.add('is-overlay');
    document.body.classList?.add('is-filter-overlay');
    document.body.classList?.add('is-locked');

    const filterDrawer = document.querySelector('.ku_landing_left_facets');
    filterDrawer.classList?.add('is-active');
    sessionStorage.setItem('klevu-filters-open', true);
  }

  /**
   * Close filter drawer.
   */
  function closeFilterDrawer() {
    document.body.classList?.remove('is-overlay');
    document.body.classList?.remove('is-filter-overlay');
    document.body.classList?.remove('is-locked');
    document.body.classList?.remove('klevu-filters-open');

    const filterDrawer = document.querySelector('.ku_landing_left_facets');
    filterDrawer.classList?.remove('is-active');
    sessionStorage.removeItem('klevu-filters-open');
  }

  /**
   * Before activation.
   */
  klevu.beforeActivation('catnav,landing', function(data, scope) {

    /**
     * Set custom templates.
     */
    scope.kScope.template.setTemplate(templateBase, 'klevuTemplateLanding', true);
    scope.kScope.template.setTemplate(templateInfinite, 'klevuLandingTemplateInfiniteScrollDown', true);
    scope.kScope.template.setTemplate(templatePagination, 'pagination', true);
    scope.kScope.template.setTemplate(templateProductCard, 'productBlock', true);
    scope.kScope.template.setTemplate(templateFilters, 'filters', true);
    scope.kScope.template.setTemplate(templateFilterTags, 'kuFilterTagsTemplate', true);
    scope.kScope.template.setTemplate(templateResults, 'results', true);
    scope.kScope.template.setTemplate(templateSortBy, 'sortBy', true);
    scope.kScope.template.setTemplate(templateTabResults, 'tab-results', true);
    scope.kScope.template.setTemplate(templateContentBlock, 'contentBlock', true);

    /**
     * Custom sorting.
     */
    scope.kScope.template.setHelper('getSortByCustom', function (name) {
      var landingStorage = klevu.getSetting(klevu.settings, 'settings.storage');

      var sorting = landingStorage.sort.getElement(name) === name
        ? 'RELEVANCE'
        : landingStorage.sort.getElement(name);

      var selectedText = '';

      switch (sorting) {
        case 'RELEVANCE':
          selectedText = window.theme.strings.collection.sorting.relevance;
          break;
        case 'PRICE_ASC':
          selectedText = window.theme.strings.collection.sorting.price_asc;
          break;
        case 'PRICE_DESC':
          selectedText = window.theme.strings.collection.sorting.price_desc;
          break;
        case 'NAME_ASC':
          selectedText = window.theme.strings.collection.sorting.name_asc;
          break;
        case 'NAME_DESC':
          selectedText = window.theme.strings.collection.sorting.name_desc;
          break;
        case 'NEW_ARRIVAL_ASC':
            selectedText = window.theme.strings.collection.sorting.new_arrival_asc;
            break;
        case 'NEW_ARRIVAL_DESC':
          selectedText = window.theme.strings.collection.sorting.new_arrival_desc;
          break;
        default:
          selectedText = window.theme.strings.collection.sorting.relevance;
      }

      return selectedText;
    })

    /**
     * Remove scroll to top.
     */
    scope.kScope.chains.events.keyUp.remove({name: 'scrollToTop'});

    /**
     * Enable load more button.
     */
    scope.kScope.chains.template.events.add({
      name: 'hideLoadMoreButtonForWindowScroll',
      fire: function(data, scope) {
        return true;
      },
    });

    window.onscroll = function() {
      if (
        window.innerHeight + Math.ceil(window.pageYOffset) >=
        document.body.offsetHeight - 50
      ) {
        var hasAlreadyTriggered = klevu.getObjectPath(
          klevu.search.landing.getScope().data,
          'context.triggeredFromInfiniteScroll'
        );

        if (!hasAlreadyTriggered) {
          return true;
        }
      }
    };

    /**
     * Additional functions.
     */
    let hasFilterTogglerAttached = false;

    /**
     * Update filters to only action on apply.
     */
    function attachFacetItemsClickEvent(scope) {
      var target = klevu.getSetting(scope.settings, 'settings.search.searchBoxTarget');

      klevu.each(klevu.dom.find('.klevuFilterOption', target), function (key, value) {
        klevu.event.attach(value, 'click', function (event) {
          event = event || window.event;
          event.preventDefault();

          var parentElem = klevu.dom.helpers.getClosest(this, '.klevuFilter');

          if (parentElem !== null && (parentElem.dataset.singleselect === 'true') && !this.classList.contains('klevuFilterOptionActive')) {
            var listSingleSelect = klevu.dom.find('.klevuFilterOptionActive', parentElem);

            klevu.each(listSingleSelect, function (key, value) {
              value.classList.remove('klevuFilterOptionActive');
            });
          }

          this.classList.toggle('klevuFilterOptionActive');
          this.closest('li').classList.toggle('kuSelected');
          this.closest('ul').classList.toggle('optionPicked');

          /**
           * Get scope.
           */
          var target = klevu.dom.helpers.getClosest(this, '.klevuTarget');

          if (target === null) {
            return;
          }

          var elScope = target.kElem;
          elScope.kScope.data = elScope.kObject.resetData(elScope.kElem);
          elScope.kScope.data.context.keyCode = 0;
          elScope.kScope.data.context.eventObject = event;
          elScope.kScope.data.context.event = 'keyUp';
          elScope.kScope.data.context.preventDefault = false;

          /**
           * Override local variables.
           */
          var options = klevu.dom.helpers.getClosest(this, '.klevuMeta');
          if (options === null) {
            return;
          }

          /**
           * Calculate new filters.
           */
          var filterList = [];
          var listActive = klevu.dom.find('.klevuFilterOptionActive', options);

          if (listActive.length > 0) {
            klevu.each((listActive), function(key, value) {
              var filter = klevu.dom.helpers.getClosest(value, '.klevuFilter');

              if (filter !== null) {
                var objectToChange = filterList.filter(function(element) {
                  return element.key == filter.dataset.filter;
                });

                if (objectToChange.length === 0) {
                  filterList.push({
                    key: filter.dataset.filter,
                    settings: {
                      singleSelect: (klevu.isUndefined(filter.dataset.singleselect) ? false : filter.dataset.singleselect)
                    },
                    values: [(klevu.isUndefined(value.dataset.value) ? false : value.dataset.value)]
                  });

                } else {
                  objectToChange[0].values.push((klevu.isUndefined(value.dataset.value) ? false : value.dataset.value));
                }
              }
            });
          }

          var rangeFilterSettings = klevu.search.modules.kmcInputs.base.getFacetRangeFilterSettings();
          var existingSelectedFilterList = klevu.getObjectPath(elScope.kScope.data, 'localOverrides.query.' + options.dataset.section + '.filters.applyFilters.filters');

          if (
            rangeFilterSettings &&
            rangeFilterSettings.minMax === 'true' &&
            existingSelectedFilterList
          ) {
            klevu.each((existingSelectedFilterList), function(key, selectedFilter) {
              if (selectedFilter.key == rangeFilterSettings.key) {
                filterList.push(selectedFilter);
              }
            });
          }

          if (filterList.length) {
            klevu.setObjectPath(elScope.kScope.data, 'localOverrides.query.' + options.dataset.section + '.filters.applyFilters.filters', filterList);
          } else {
            klevu.setObjectPath(elScope.kScope.data, 'localOverrides.query.' + options.dataset.section + '.filters.applyFilters', {});
          }

          /**
           * Reset offset after filter change.
           */
          klevu.setObjectPath(elScope.kScope.data, 'localOverrides.query.' + options.dataset.section + '.settings.offset', 0);
        }, true);
      });
    }

    var facets = { attachFacetItemsClickEvent: attachFacetItemsClickEvent };

    (function(klevu) {
      klevu.extend(true, klevu.search.modules, {
        facets: {
          base: facets,
          build: true
        },

        /**
         * Add parameters to URL.
         */
        addParamsToURL: {
          base: {

            /**
             * Update history state.
             */
            addURLtoHistory: function(data, scope, queryId) {
              if (typeof window.history === 'undefined' || typeof window.history.pushState === 'undefined') {
                return;
              }

              var searchPath = new URLSearchParams(window.location.search);
              var currentSearchPath;
              var previousSearchPath = searchPath.toString();

              // In case we're running our code where we don't have context.activeQueryId
              var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");

              if (queryId && queryId.length) {
                activeQueryId = queryId;
              }

              // Check if there any filter selected
              let applyFilters = typeof data.localOverrides.query[activeQueryId].filters !== 'undefined'
                ? data.localOverrides.query[activeQueryId].filters.applyFilters
                : {};

              let isThereFiltersSelected = false;

              // Check if applyFilters is an object (but not an array), and not empty
              if (
                typeof applyFilters === 'object' &&
                !Array.isArray(applyFilters) &&
                applyFilters !== null &&
                Object.keys(applyFilters).length
              ) {
                isThereFiltersSelected = true;
              }

              /**
               * Add pagination parameter to URL.
               */
              var hasPaginationEnabled = klevu.getSetting(klevu, 'settings.theme.modules.pagination.searchResultsPage.enable');
              var paginationQueryParam = 'Page';
              var currentPage = 0;

              if (hasPaginationEnabled) {
                var activeQueryMeta = klevu.getObjectPath(data, 'template.query.' + activeQueryId + '.meta');

                if (activeQueryMeta) {
                  var productListLimit = activeQueryMeta.noOfResults;
                  currentPage = Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
                }

                if (currentPage === 0 || currentPage === 1) {
                  searchPath.delete(paginationQueryParam);
                } else {
                  searchPath.set(paginationQueryParam, currentPage);
                }

                currentSearchPath = searchPath.toString();
              };

              /**
               * Add filter parameters to URL.
               */
              var activeQueryFilters = klevu.getObjectPath(data, 'template.query.' + activeQueryId + '.filters');
              var filterValuesQueryParam = '';

              if (activeQueryFilters) {
                let count = 0

                klevu.each(activeQueryFilters, function(key, filter) {
                  var selectedFilterKeyString = '';
                  var filterOptions = filter.options;
                  var selectedValues = '';

                  if (filterOptions && filterOptions.length) {
                    klevu.each(filterOptions, function(key, option) {
                      if (option.selected === true) {
                        if (selectedValues.length) {
                          selectedValues += ',';
                        }

                        selectedValues += option.value;
                      }
                    });

                  } else if (filter.type === 'SLIDER') {
                    var startValue = filter.start;
                    var endValue = filter.end;
                    var minValue = filter.min;
                    var maxValue = filter.max;

                    if (
                      typeof startValue !== 'undefined' &&
                      startValue !== null &&
                      typeof endValue !== 'undefined' &&
                      endValue !== null
                    ) {
                      if (
                        Number(startValue) === Number(minValue) &&
                        Number(endValue) === Number(maxValue)
                      ) {
                        // Skipped
                      } else {
                        selectedValues = startValue + '-' + endValue;
                      }
                    }
                  }

                  if (selectedValues.length) {
                    selectedFilterKeyString += encodeURIComponent(filter.key) + ':' + encodeURIComponent(selectedValues);
                    count += selectedValues.split(',')?.filter(Boolean)?.length
                  }

                  if (selectedFilterKeyString.length) {
                    if (filterValuesQueryParam.length) {
                      filterValuesQueryParam += ';';
                    }

                    filterValuesQueryParam += selectedFilterKeyString;
                  }
                });

                window.activeFilterCount = count
              }

              if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
                searchPath.set('Filters', filterValuesQueryParam);
              } else {
                searchPath.delete('Filters');
              }

              currentSearchPath = searchPath.toString();

              /**
               * Final URL change.
               */
              if (previousSearchPath !== currentSearchPath) {
                var historyState = { page: currentPage, filters: currentSearchPath };
                window.history.pushState(historyState, null, currentSearchPath ? '?' + currentSearchPath : window.location.pathname);
              }
            },

            /**
             * Restore parameters on page load.
             */
            restoreSearchParamsOnPageLoad: function(data, scope) {
              var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, 'element.kScope.getAndUpdateFiltersTriggered');

              if (hasAlreadyTriggered) {
                return;
              }

              var activeQueryId = klevu.getObjectPath(data, 'context.activeQueryId') || 'productList';

              var filtersFromURL = klevu.dom.helpers.getQueryStringValue('Filters');
              var paginationFromURL = klevu.dom.helpers.getQueryStringValue('Page');

              var matchedQueryParamId = '';
              var matchedQueryParamValue = '';
              var recordQueries = klevu.getObjectPath(data, 'request.current.recordQueries');

              if (recordQueries && recordQueries.length) {
                klevu.each(recordQueries, function(key, recordQuery) {
                  if (recordQuery.id) {
                    if (
                      (paginationFromURL && paginationFromURL.length) ||
                      (filtersFromURL && filtersFromURL.length)
                    ) {
                      matchedQueryParamId = recordQuery.id;
                      matchedQueryParamValue = paginationFromURL || filtersFromURL;
                    }
                  }
                });
              }

              klevu.setObjectPath(scope.kScope, 'element.kScope.getAndUpdateFiltersTriggered', true);

              matchedQueryParamId = activeQueryId || 'productList';

              if (matchedQueryParamId.length && matchedQueryParamValue.length) {
                activeQueryId = matchedQueryParamId;
                var storage = klevu.getSetting(scope.kScope.settings, 'settings.storage');

                if (storage.tabs) {
                  storage.tabs.setStorage('local');
                  storage.tabs.mergeFromGlobal();
                  storage.tabs.addElement('active', activeQueryId);
                  storage.tabs.mergeToGlobal();
                }
              }

              if (paginationFromURL && paginationFromURL > 1) {
                if (recordQueries && recordQueries.length) {
                  klevu.each(recordQueries, function(key, recordQuery) {
                    if (recordQuery.id === activeQueryId) {
                      var limit = klevu.getObjectPath(recordQuery, 'settings.limit');
                      limit = Number(limit);

                      if (limit > 0) {
                        var expectedOffset = (paginationFromURL - 1) * limit;
                        klevu.setObjectPath(data, 'localOverrides.query.' + activeQueryId + '.settings.offset', expectedOffset);
                      }
                    }
                  });
                }
              }

              /**
               * Filters
               */
              if (filtersFromURL && filtersFromURL.length) {
                var facets = filtersFromURL.split(';');

                if (facets) {
                  klevu.each(facets, function(key, facet) {
                    var splitFacet = facet.split(':');

                    if (splitFacet.length) {
                      var facetKey = decodeURIComponent(splitFacet[0]);
                      var facetValues = decodeURIComponent(splitFacet[1]).split(',');
                      var applyFilters = klevu.getObjectPath(data, 'localOverrides.query.' + activeQueryId + '.filters.applyFilters.filters');

                      // If there's filters
                      if (applyFilters && applyFilters.length) {
                        var isExistingKey = false;

                        klevu.each(applyFilters, function(key, applyFilter) {
                          if (applyFilter.key === facetKey) {
                            isExistingKey = true;
                            klevu.each(facetValues, function(key, facetValue) {
                              var isFilterOptionMatched = false;

                              klevu.each(applyFilter.values, function(key, value) {
                                if (facetValue === value) {
                                  isFilterOptionMatched = true;
                                }
                              });

                              if (!isFilterOptionMatched) {
                                applyFilter.values.push(facetValue);
                              }
                            });
                          }
                        });

                        if (!isExistingKey) {
                          applyFilters.push({ key: facetKey, values: facetValues });
                        }

                      } else {
                        klevu.setObjectPath(data, 'localOverrides.query.' + activeQueryId + '.filters.applyFilters.filters', [{ key: facetKey, values: facetValues }]);
                      }
                    }
                  });
                }
              }
            },

            /**
             * Update payload on popstate.
             */
            updatePayloadOnPopState: function(data, scope, activeQueryId) {

              /**
               * Set pagination payload.
               */
              var paginationFromURL = klevu.dom.helpers.getQueryStringValue('Page');
              paginationFromURL = Number(paginationFromURL);
              var limit = window.klevuCurrentScope.element.kObject.getScope().data.request.original.queryRequest[0].settings.limit;
              limit = Number(limit);

              if (limit > 0) {
                var expectedOffset = ((paginationFromURL - 1) * limit) > 0 ? ((paginationFromURL - 1) * limit) : 0;
                klevu.setObjectPath(data, 'localOverrides.query.' + activeQueryId + '.settings.offset', expectedOffset);
              }

              /**
               * Set filter payload.
               */
              var filtersFromURL = klevu.dom.helpers.getQueryStringValue('Filters');

              if (filtersFromURL && filtersFromURL.length) {
                var facets = filtersFromURL.split(';');
                let facetKey = '';
                let facetValues = [];
                let facetsArray = [];

                // Loop through all facets to get its values
                klevu.each(facets, function(key, facet) {
                  var splitFacet = facet.split(':');

                  if (splitFacet.length) {
                    facetKey = decodeURIComponent(splitFacet[0]);
                    facetValues = decodeURIComponent(splitFacet[1]).split(',');
                    facetsArray.push({ key: facetKey, values: facetValues });
                  }
                });

              } else {
                klevu.setObjectPath(data, 'localOverrides.query.' + activeQueryId + '.filters.applyFilters.filters', []);
              }
            }
          },
          build: true
        },

        /**
         * Filters functionality
         */
        filterFunctionality: function() {
          const selectors = {
            kuCollapse: '.kuCollapse',
            kuExpand: '.kuExpand',
            kuFilterBox: '.kuFilterBox',
            kuFilterCollapse: '.kuFilterCollapse',
            kuFilterHead: '.kuFilterHead',
            kuFilterHeadExpand: '.kuFilterHead.kuExpand',
            kuFilterNames: '.kuFilterNames',
            kuFilterNamesCollapse: '.kuFilterNames.kuFilterCollapse',
            kuFilterShowAll: '.kuFilterShowAll',
            kuSelected: '.kuSelected',
            nouiElement: '.noUi-origin',
            priceFacetBlock: '[data-filter="klevu_price"]',
            kuFilterOption: '.klevuFilterOption',
            kuFilterIcon: '.kuFilterIcon',
          };

          /**
           * Collapse all filters.
           */
          const kuFilterHeadElements = document.querySelectorAll(selectors.kuFilterHead);

          kuFilterHeadElements.forEach(element => {
            element.classList.add(selectors.kuExpand.substring(1));
            element.classList.remove(selectors.kuCollapse.substring(1));
          });

          const kuFilterNamesElements = document.querySelectorAll(selectors.kuFilterNames);

          kuFilterNamesElements.forEach(element => {
            element.classList.add(selectors.kuFilterCollapse.substring(1));
            element.classList.remove(selectors.kuFilterShowAll.substring(1));
          });

          /**
           * Expand filter if it has an option that is selected.
           */
          const kuSelectedListItems = document.querySelectorAll('li.kuSelected');

          kuSelectedListItems.forEach((listItem) => {
            const filterBox = findParentWithClass(listItem, selectors.kuFilterBox);
            const filterHead = filterBox.querySelector(selectors.kuFilterHead);
            const filterNames = findParentWithClass(listItem, selectors.kuFilterNames);

            if (filterHead) {
              filterHead.classList.remove('kuExpand');
              filterHead.classList.add('kuCollapse');
            }

            if (filterNames) {
              filterNames.classList.remove('kuFilterCollapse')
            }
          });

          /**
           * Helper to find parent element with a specified class.
           * @returns {HTMLElement|Null}
           */
          function findParentWithClass(element, className) {
            let parent = element.parentElement;

            while (parent) {
              if (parent.matches(className)) {
                return parent;
              }

              parent = parent.parentElement;
            }

            return null;
          }
        },

        /**
         * Toggle filters.
         */
        filterToggler: function(documentBody, klevuLanding) {
          if (hasFilterTogglerAttached) {
            return;
          }

          hasFilterTogglerAttached = true;

          /**
           * Close filter drawer if clicking overlay.
           */
          klevu.event.attach(documentBody, 'click', function(event) {
            const { target } = event;

            if (!target.matches('.is-overlay')) {
              return
            }

            closeFilterDrawer();
          });

          klevu.event.attach(klevuLanding, 'click', function(event) {
            const { target } = event;

            /**
             * Toggle filters when the filter button is clicked.
             */
            if (target.matches('.klevu__toggle-filters, .klevu__toggle-filters *')) {
              openFilterDrawer();
              return;
            }

            /**
             * Close filters when 'close' button is clicked.
             */
            if (
              target.matches('[js-klevu-filters="close"]') ||
              target.matches('[js-klevu-filters="reset"')
            ) {
              closeFilterDrawer();
              return;
            }

            /**
             * Close filters when 'apply' button is clicked.
             */
            if (target.matches('.kuFiltersButton_apply') ) {
              var _target = klevu.dom.helpers.getClosest(this, '.klevuTarget');

              if (target === null) {
                return;
              }

              var elScope = _target.kElem;
              klevu.event.fireChain(elScope.kScope, "chains.events.keyUp", elScope, elScope.kScope.data, event);
              closeFilterDrawer();
              return;
            }
          });
        },
      });
    })(klevu);
  });

  /**
   * After render.
   */
  klevu.afterTemplateRender('catnav,landing', function(data, scope) {
    const klevuLanding = document.getElementsByClassName('klevuLanding')[0];

    klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
    klevu.search.modules.filterToggler(document.body, klevuLanding);
    klevu.search.modules.filterFunctionality();

    /**
     * Open filter drawer if sessionStorage exists.
     * - Means price filter has re-rendered the page.
     */
    if (sessionStorage.getItem('klevu-filters-open')) {
      document.body.classList?.add('klevu-filters-open');
      openFilterDrawer();
    }

    /**
     * Programmatically click apply when removing active filters.
     * - Otherwise nothing happens.
     */
    const activeTags = document.querySelectorAll('[js-klevu-filters="active"')
    const applyButton = document.querySelector('[js-klevu-filters="apply"]')

    activeTags?.forEach((activeTag) => {
      activeTag.addEventListener('click', function() {
        setTimeout(() => {
          if (!applyButton) {
            return
          }

          applyButton.click()
        }, 100);
      })
    })

    /**
     * Count number of selected filters.
     */
    function filterCounter() {
      let count = 0;

      return {
        increment: function () {
          count++;
        },
        decrement: function () {
          if (count > 0) {
            count--;
          }
        },
        setCount: function (newCount) {
          count = newCount;
        },
        getCount: function () {
          return count;
        },
      };
    }

    const counter = filterCounter();

    /**
     * Update filter count text.
     */
    function updateFilterCount() {
      const filterHeading = document.querySelector('[js-klevu-filters="title"]');
      const clearAllButton = document.querySelector('[js-klevu-filters="reset"]');
      const count = counter.getCount();

      if (filterHeading) {
        const filterString = count
          ? window.theme.strings.collection.filters.filter_by_count
          : window.theme.strings.collection.filters.filter_by

        filterHeading.innerText = filterString.replaceAll('{{ count }}', count);
      }

      if (clearAllButton) {
        const clearAllString = count
          ? window.theme.strings.collection.filters.clear_all_count
          : window.theme.strings.collection.filters.clear_all

          clearAllButton.innerText = clearAllString.replaceAll('{{ count }}', count);
      }
    }

    /**
     * Initialise filter count.
     */
    function initializeFilterCount() {
      counter.setCount(window.activeFilterCount);
      updateFilterCount();
    }

    /**
     * Add click event to options to update filter count.
     */
    document.querySelectorAll('.klevuFilterOption')?.forEach((option) => {
      option.addEventListener('click', function () {
        const parentLi = this.closest('li');

        if (parentLi.classList.contains('kuSelected')) {
          counter.increment();
        } else {
          counter.decrement();
        }

        updateFilterCount();
      });
    });

    initializeFilterCount();
  });

  /**
   * After search render.
   * - Save current tab type so load more opens correct tab.
   */
  klevu.afterTemplateRender('landing', function(data, scope) {
    var tabs = document.querySelectorAll('[js-search="tab"]')

    tabs.forEach((element) => {
      element.addEventListener('click', () => {
        var type = element.dataset.section
        sessionStorage.setItem('klevu-current-tab', type)
      })
    })

    var type = sessionStorage.getItem('klevu-current-tab') || 'productList'

    if (type === 'contentList') {
      var tab = document.querySelector('[js-search="tab"][data-section="contentList"]')

      if (tab) {
        setTimeout(() => {
          tab.click()
        }, 100);
      }
    }
  })

  /**
   * Back navigation listener.
   */
  window.onpopstate = function(event) {
    try {
      // Passing activeQueryId because it's lost once we reset the data below
      var activeQueryId = klevu.getObjectPath(window.klevuCurrentScope.element.kObject.getScope().data, 'context.activeQueryId');

      // Code to get ready to reset all the data
      var data = window.klevuCurrentScope.element.kObject.getScope().data;
      var scope = window.klevuCurrentScope.element;
      scope.kScope.data = scope.kObject.resetData(scope.kElem);
      scope.kScope.data.context.keyCode = 0;
      scope.kScope.data.context.eventObject = event;
      scope.kScope.data.context.event = 'keyUp';
      scope.kScope.data.context.preventDefault = false;

      // Get payload for Filters & Pagination
      klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(data, scope, activeQueryId);

      // Fire request, re-render results
      klevu.event.fireChain(scope.kScope, 'chains.events.keyUp', scope, scope.kScope.data, event);

    } catch (error) {
      console.log(error)
    }
  };

  klevu.support.hook(['recs'], function() {
    klevu({
      powerUp: {
        catnav: true,
        landing: true,
      },
    });
  });
});

/**
 * Template base.
 */
var templateBase = `
<div
  data-container-id="ku_landing_main_container"
  data-container-role="main"
>
  <header
    data-container-id="ku_landing_main_header_container"
    data-container-role="header"
  >
    <section ku-block data-block-id="ku_landing_main_header_sub_panel"></section>
    <section ku-block data-block-id="ku_landing_main_header_banner"></section>

    <section ku-block data-block-id="ku_landing_main_header_site_navigation"></section>

    <input
      id="searchedKeyword"
      type="hidden"
      value=""
    />
  </header>

  <div class="kuContainer">
    <% if (!helper.hasResults(data,"productList") && !helper.hasFilters(data,"productList") && !helper.hasResults(data,"contentList") && !helper.hasFilters(data,"contentList")) { %>
      <%= helper.render('noResultsFoundLanding',scope) %>

    <% } else { %>
      <%= helper.render('tab-results', scope) %>
      <%= helper.render('results',scope) %>
    <% } %>
  </div>

  <footer
    data-container-id="ku_landing_main_footer_container"
    data-container-role="footer"
  >
    <section ku-block data-block-id="ku_landing_main_footer_sub_panel"></section>
    <section ku-block data-block-id="ku_landing_main_footer_banner"></section>
  </footer>
</div>`;

/**
 * Infinite scroll.
 */
var templateInfinite = `
<button
  class="klevu__load-more button button--secondary kuLoadMoreBtn"
  type="button"
>
  <span class="klevu__load-more-text">
    <%= window.theme.strings.collection.general.load_more %>
  </span>

  <span class="klevu__load-more-icon">
    <%= window.theme.icon.loading %>
  </span>
</button>`;

/**
 * Pagination.
 */
var templatePagination = `
<%
  var allClassName = 'all-' + dataLocal

  if (data.query[dataLocal].result.length < 1) {
    document.body.classList.add(allClassName)
  }
%>

<% if (data.query[dataLocal].result.length > 0) { %>
  <%
    var resultsPerPage = data.query[dataLocal].meta.noOfResults;
    var totalResultsFound = data.query[dataLocal].meta.totalResultsFound;
    var currentOffset = data.query[dataLocal].meta.offset;

    var currentProducts = currentOffset + resultsPerPage

    if (currentProducts > totalResultsFound) {
      var currentProducts = totalResultsFound
    }

    var progressWidth = (currentProducts / totalResultsFound) * 100

    if (currentProducts >= totalResultsFound) {
      document.body.classList.add(allClassName)
    } else {
      document.body.classList.remove(allClassName)
    }
  %>

  <div class="klevu__progress">
    <div class="klevu__progress-bar">
      <div
        class="klevu__progress-fill"
        style="width: <%= progressWidth %>%;"
      ></div>
    </div>

    <p class="klevu__progress-text caption">
      <%
        var paginationString = window.theme.strings.collection.general.pagination

        if (dataLocal === 'contentList') {
          var paginationString = window.theme.strings.collection.general.pagination_pages
        }
      %>

      <%= paginationString.replace('{{ current }}', currentProducts).replace('{{ total }}', totalResultsFound) %>
    </p>
  </div>
<% } %>`;

/**
 * Product card template.
 */
var templateProductCard = `
<% var handle = dataLocal.url.split('products/')[1] %>

<li
  class="klevu__product-item klevuProduct klevuProductClick kuTrackRecentView"
  data-id="<%= dataLocal.id %>"
>
  <product-card
    class="product-card"
    handle="<%= handle %>"
    query="true"
  >
    <div
      class="product-card__container"
      js-product-card="container"
    >
      <div class="product-card__image-container">
        <div
          class="product-card__image-controls"
          js-product-card="imageControls"
        >
          <button
            class="product-card__quickview-button"
            type="button"
            js-product-card="quickviewButton"
          >
            <span class="visually-hidden">
              <%= window.theme.strings.collection.header.quickview %>
            </span>

            <%= window.theme.icon.plus %>

            <span class="product-card__quickview-button-loading">
              <%= window.theme.icon.loading %>
            </span>

            <span class="product-card__quickview-button-error">
              <%= window.theme.icon.close %>
            </span>
          </button>
        </div>

        <div
          class="product-card__hover-quickview"
          js-product-card="hoverQuickview"
        ></div>

        <a
          class="
            product-card__link
            klevuProduct
            klevuProductClick
            kuTrackRecentView
          "
          href="<%= dataLocal.url %>"
          data-id="<%= dataLocal.id %>"
        >
          <% if (dataLocal.image) { %>
            <img
              class="product-card__image"
              alt="<%= dataLocal.name %>"
              loading="lazy"
              sizes="auto"
              src="<%= dataLocal.image.replace('_medium', '') %>&width=1000"
              srcset="
                <%= dataLocal.image.replace('_medium', '') %>&width=200 200w,
                <%= dataLocal.image.replace('_medium', '') %>&width=300 300w,
                <%= dataLocal.image.replace('_medium', '') %>&width=400 400w,
                <%= dataLocal.image.replace('_medium', '') %>&width=500 500w,
                <%= dataLocal.image.replace('_medium', '') %>&width=600 600w,
                <%= dataLocal.image.replace('_medium', '') %>&width=700 700w,
                <%= dataLocal.image.replace('_medium', '') %>&width=800 800w,
                <%= dataLocal.image.replace('_medium', '') %>&width=900 900w
              "
            >
          <% } else { %>
            <div class="product-card__empty-image"></div>
          <% } %>

          <% if (dataLocal.imageHover) { %>
            <img
              class="product-card__hover-image"
              alt="<%= dataLocal.name %>"
              loading="lazy"
              sizes="auto"
              src="<%= dataLocal.imageHover.replace('_medium', '') %>&width=1000"
              srcset="
                <%= dataLocal.imageHover.replace('_medium', '') %>&width=200 200w,
                <%= dataLocal.imageHover.replace('_medium', '') %>&width=300 300w,
                <%= dataLocal.imageHover.replace('_medium', '') %>&width=400 400w,
                <%= dataLocal.imageHover.replace('_medium', '') %>&width=500 500w,
                <%= dataLocal.imageHover.replace('_medium', '') %>&width=600 600w,
                <%= dataLocal.imageHover.replace('_medium', '') %>&width=700 700w,
                <%= dataLocal.imageHover.replace('_medium', '') %>&width=800 800w,
                <%= dataLocal.imageHover.replace('_medium', '') %>&width=900 900w
              "
            >
          <% } %>
        </a>
      </div>

      <a
        class="
          product-card__footer
          klevuProduct
          klevuProductClick
          kuTrackRecentView
        "
        href="<%= dataLocal.url %>"
        tabindex="-1"
        data-id="<%= dataLocal.id %>"
        js-product-card="link"
      >
        <p class="product-card__title subtitle-2">
          <%= dataLocal.name %>
        </p>

        <div class="product-card__meta">
          <div
            class="product-card__price is-loading"
            js-product-card="price"
          ></div>

          <% if (window.theme.features.wishlist) { %>
            <button
              class="
                product-card__wishlist
                iWishAddColl
                iwishcheck
              "
              data-variant="<%= dataLocal.id %>"
              data-product="<%= dataLocal.itemGroupId %>"
              data-pTitle="<%= dataLocal.name %>"
              js-product-card="wishlist"
            >
              <%= window.theme.icon.wishlistEmpty %>

              <span class="visually-hidden">
                <%= window.theme.strings.products.product.wishlist %>
              </span>
            </button>
          <% } %>
        </div>
      </a>
    </div>
  </product-card>
</li>`;

/**
 * Filters template.
 */
var templateFilters = `
<% if (data.query[dataLocal].filters.length) { %>
  <div class="klevu-filters__container">
    <div
      class="
        klevu-filters__filters
        kuFilters
      "
      role="navigation"
      aria-label="Product Filters"
      data-position="left"
    >
      <div class="klevu-filters__header">
        <h2
          class="klevu-filters__title h2"
          js-klevu-filters="title"
        >
          <%= window.theme.strings.collection.filters.filter_by %>
        </h2>

        <button
          class="klevu-filters__close"
          type="button"
          js-klevu-filters="close"
        >
          <%= window.theme.icon.close %>
        </button>
      </div>

      <% helper.each(data.query[dataLocal].filters,function(key,filter) { %>
        <% if (filter.type === "OPTIONS") { %>
          <div
            class="
              klevu-filters__filter
              kuFilterBox
              klevuFilter
              <%= (filter.multiselect) ? 'kuMulticheck' : '' %>
            "
            data-filter="<%= filter.key %>"
            data-singleselect="<% if (filter.multiselect) { %>false<% } else { %>true<% } %>"
          >
            <button
              class="
                klevu-filters__filter-title
                subtitle-2
                kuFilterHead
                <%= (filter.isCollapsed) ? 'kuCollapse' : 'kuExpand' %>
              "
              type="button"
            >
              <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
              <%= helper.translate(filter_label) %>

              <span class="klevu-filters__show-all">
                <%= window.theme.icon.chevronDown %>

                <span class="visually-hidden">
                  <%= window.theme.strings.collection.filters.show_all %>
                </span>
              </span>
            </button>

            <div
              class="
                klevu-filters__list-container
                kuFilterNames
                <%= (filter.isCollapsed) ? 'kuFilterCollapse' : '' %>
                <%= (filter.key?.toLowerCase() === 'colour') ? 'has-swatches' : '' %>
              "
              data-optionCount="<%= filter.options.length %>"
            >
              <ul class="klevu-filters__list filterOptionList">
                <% helper.each(filter.options, function(key, filterOption) { %>
                  <li
                    class="
                      klevu-filters__list-item
                      <% if (filterOption.selected) { %>kuSelected<% } %>
                    "
                  >
                    <a
                      class="
                        klevu-filters__option
                        body-2
                        klevuFilterOption
                        <% if (filterOption.selected) { %>klevuFilterOptionActive<% } %>
                      "
                      href="#"
                      target="_self"
                      title="<%= helper.escapeHTML(filterOption.name) %> (<%= filterOption.count %>)"
                      data-name="<%= helper.escapeHTML(filterOption.name) %>"
                      data-value="<%= helper.escapeHTML(filterOption.value) %>"
                    >
                      <span class="kuFilterIcon"></span>

                      <span
                        class="klevu-filters__swatch"
                        data-color-swatch="<%= helper.escapeHTML(filterOption.value).toLowerCase().replace(' ','-') %>"
                        style="background-color: <%= window.swatchColors[helper.escapeHTML(filterOption.value)?.toLowerCase().replace(' ','-') ] || 'transparent' %>;"
                      ></span>

                      <span class="kufacet-text text-body-2">
                        <%= filterOption.name %> (<%= filterOption.count %>)
                      </span>
                    </a>
                  </li>
                <% }); %>
              </ul>
            </div>
          </div>

        <% } else if (filter.type == "SLIDER")  { %>
            <div
              class="
                klevu-filters__filter
                kuFilterBox
                klevuFilter
              "
              data-filter="<%= filter.key %>"
            >
              <div
                class="
                  klevu-filters__filter-title
                  klevu-filters__filter-title--slider
                  subtitle-2
                  kuFilterHead
                  kuFilterShowAll
                  kuCollapse
                "
                tabindex="-1"
              >
                <% var filter_label = (filter.label=="klevu_price") ? 'price' : filter.label; %>
                <%= helper.translate(filter_label) %>
              </div>

              <div
                class="
                  klevu-filters__slider-container
                  kuFilterNames
                  sliderFilterNames
                  kuFilterShowAll
                "
              >
                <div
                  class="
                    klevu-filters__slider
                    kuPriceSlider
                    klevuSliderFilter
                  "
                  data-query="<%= dataLocal %>"
                >
                  <div
                    class="
                      klevu-filters__slider-elements
                      noUi-target
                      noUi-ltr
                      noUi-horizontal
                      noUi-background
                      kuSliderFilter
                      kuPriceRangeSliderFilter<%=dataLocal%>
                    "
                    data-querykey="<%= dataLocal %>"
                  ></div>
                </div>
              </div>
            </div>

        <% } else if (filter.type == "RATING")  { %>
            <div
              class="
                klevu-filters__filter
                kuFilterBox
                klevuFilter
                <%= (filter.multiselect) ? 'kuMulticheck' : '' %>
              "
              data-filter="<%= filter.key %>"
              data-singleselect="<% if (filter.multiselect){ %>false<% } else { %>true<% } %>"
            >
              <button
                class="
                  klevu-filters__filter-title
                  subtitle-2
                  kuFilterHead
                  <%= (filter.isCollapsed) ? 'kuExpand' : 'kuCollapse' %>
                "
                type="button"
              >
                <%= helper.translate(filter.label) %>
                <span class="klevu-filters__show-all">
                  <%= window.theme.icon.chevronDown %>

                  <span class="visually-hidden">
                    <%= window.theme.strings.collection.filters.show_all %>
                  </span>
                </span>
              </button>

              <div
                class="
                  klevu-filters__list-container
                  kuFilterNames
                  <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>
                "
                data-optionCount="<%= filter.options.length %>"
              >
                <ul class="klevu-filters__list filterOptionList">
                  <% helper.each(filter.options,function(key,filterOption) { %>
                    <li
                      class="
                        klevu-filters__list-item
                        <% if (filterOption.selected) { %>kuSelected<% } %>
                      "
                    >
                      <a
                        class="
                          klevu-filters__option
                          body-2
                          klevuFilterOption
                          <% if (filterOption.selected) { %>klevuFilterOptionActive<% } %>
                        "
                        href="#"
                        target="_self"
                        title="<%= helper.escapeHTML(filterOption.name) %>"
                        data-value="<%= helper.escapeHTML(filterOption.value) %>"
                        data-name="<%= helper.escapeHTML(filterOption.name) %>"
                      >
                        <span class="kuFilterIcon"></span>

                        <span class="kufacet-text">
                          <div class="klevuFacetStars">
                            <div
                              class="klevuFacetRating"
                              style="width:<%= (20 * Number(filterOption.name)) %>%;"
                            ></div>
                          </div>
                        </span>
                      </a>
                    </li>
                  <%  }); %>
                </ul>
              </div>
            </div>

        <% } else { %>
          <!-- Other Facets -->
        <% } %>
      <% }); %>
    </div>

    <div class="klevu-filters__footer">
      <button
        class="
          button
          button--secondary
          button--outlined
          kuFiltersButton
          kuFiltersButton_reset
          kuFilterTagClearAll
        "
        type="button"
        js-klevu-filters="reset"
      >
        <%= window.theme.strings.collection.filters.clear_all %>
      </button>

      <button
        class="
          button
          button--secondary
          kuFiltersButton
          kuFiltersButton_apply
          ku_applyFilters
        "
        type="button"
        js-klevu-filters="apply"
      >
        <%= window.theme.strings.collection.filters.apply %>
      </button>
    </div>
  </div>
<% } %>`;

/**
 * Results wrapper template.
 */
var templateResults = `
<div class="kuResultsListing">
  <div
    class="productList klevuMeta"
    data-section="productList"
    js-klevu="list"
  >
    <div class="kuResultContent">
      <div
        class="
          kuResultWrap
          <%= (data.query.productList.filters.length === 0) ? 'kuBlockFullwidth' : '' %>
        "
      >
        <div
          data-container-id="ku_landing_main_content_container"
          data-container-role="content"
        >
          <section
            data-container-id="ku_landing_main_content_left"
            data-container-position="left"
            data-container-role="left"
          >
            <div
              class="klevu-filters"
              ku-block
              data-block-id="ku_landing_left_facets"
            ></div>

            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
            <div ku-block data-block-id="ku_landing_left_banner"></div>
          </section>

          <section
            data-container-id="ku_landing_main_content_center"
            data-container-position="center"
            data-container-role="center"
          >
            <header
              class="klevu__header
              ku-block
              data-block-id="ku_landing_result_header"
            >
              <button
                class="
                  klevu__toggle-filters
                  Filter__filterToggle
                  js-filterToggle
                  button
                  button--secondary
                "
                aria-label="Show collection filter"
              >
                <%= window.theme.strings.collection.header.filter_by %>
              </button>

              <%= helper.render('filtersTop',scope,data,"productList") %>

              <% if(helper.hasResults(data,"productList")) { %>
                <%=helper.render('sortBy',scope,data,"productList") %>
              <% } %>

              <div
                class="ku_landing_left_facets klevu-filters"
                ku-block
                data-block-id="ku_landing_left_facets"
                data-container-role="left"
              >
                <%=helper.render('filters',scope,data,"productList") %>
              </div>
            </header>

            <div
              ku-block
              data-block-id="ku_landing_result_items"
            >
              <div class="FilterUnderlay"></div>

              <div class="kuFilterTagsDesktop">
                <%= helper.render('kuFilterTagsTemplate', scope, data, 'productList') %>
              </div>

              <div class="kuResults">
                <% if (helper.hasResults(data, 'productList')) { %>
                  <ul class="klevu__product-grid">
                    <% if (window.renderInGridBanner && window.renderKlevuBanner && data.banners) { %>
                      <% helper.each(data.banners.top, function(index, item) { %>
                        <in-grid-banner
                          class="
                            klevu__in-grid-banner
                            klevu__in-grid-banner--small
                            klevu__in-grid-banner--klevu
                          "
                          cta-label="<%= window.theme.strings.collection.banner.shop_now %>"
                          cta-url="<%= item.redirectUrl %>"
                          mob-src="<%= item.mobileBannerImageUrl %>"
                          src="<%= item.bannerImg %>"
                          subtitle=""
                          title=""
                          type="image"
                        ></in-grid-banner>
                      <% }); %>
                    <% } %>

                    <% helper.each(data.query.productList.result, function(index, item) { %>
                      <% if (item.typeOfRecord === 'IN_GRID_BANNER') { %>
                        <% if (window.renderInGridBanner) { %>
                          <in-grid-banner
                            class="
                              klevu__in-grid-banner
                              klevu__in-grid-banner--<%= item.desktopImageHeight %>
                              klevu__in-grid-banner--metafield
                            "
                            cta-label="<%= item.ctaLabel %>"
                            cta-url="<%= item.ctaUrl %>"
                            mob-src="<%= item.mobSrc %>"
                            src="<%= item.src %>"
                            subtitle="<%= item.subtitle %>"
                            title="<%= item.title %>"
                            type="<%= item.type %>"
                          ></in-grid-banner>
                        <% } %>

                      <% } else if (item.typeOfRecord === 'KLEVU_PRODUCT') { %>
                        <%= helper.render('productBlock', scope, data, item) %>
                      <% } %>
                    <% }); %>
                  </ul>

                <% } else { %>
                  <div class="klevu__no-results">
                    <span class="body-2">
                      <%= window.theme.strings.general.search.no_results_html %>
                    </span>
                  </div>
                <% } %>
              </div>

              <div class="klevu__pagination">
                <%= helper.render('klevuLandingTemplateInfiniteScrollDown', scope, data) %>
                <%= helper.render('pagination',scope, data, 'productList') %>
              </div>
            </div>

            <div ku-block data-block-id="ku_landing_other_items"></div>
            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
          </section>

          <section
            data-container-id="ku_landing_main_content_right"
            data-container-position="right"
            data-container-role="right"
          >
            <div ku-block data-block-id="ku_landing_right_facets"></div>
            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
            <div ku-block data-block-id="ku_landing_right_banner"></div>
          </section>
        </div>
      </div>
    </div>
  </div>

  <% if (data.query.contentList) { %>
    <div
      class="contentList klevuMeta"
      data-section="contentList"
      data-result-view="list"
      js-klevu="list"
    >
      <div class="kuResultContent">
        <div
          class="
            kuResultWrap
            <%= (data.query.contentList.filters.length === 0) ? 'kuBlockFullwidth' : '' %>
          "
        >
          <div
            data-container-id="ku_landing_main_content_container"
            data-container-role="content"
          >
            <section
              data-container-id="ku_landing_main_content_left"
              data-container-position="left"
              data-container-role="left"
            >
              <div
                class="klevu-filters"
                data-block-id="ku_landing_left_facets"
              >
                <%= helper.render('filters',scope,data,"contentList") %>
              </div>

              <div data-block-id="ku_landing_left_call_outs"></div>
              <div data-block-id="ku_landing_left_banner"></div>
            </section>

            <section
              data-container-id="ku_landing_main_content_center"
              data-container-position="center"
              data-container-role="center"
            >
              <header data-block-id="ku_landing_result_header">
                <%= helper.render('filtersTop', scope, data, 'contentList') %>
                <%= helper.render('kuFilterTagsTemplate', scope, data, 'contentList') %>
              </header>

              <div data-block-id="ku_landing_result_items">
                <div class="kuResults">
                  <% if (helper.hasResults(data, 'contentList')) { %>
                    <ul>
                      <% helper.each(data.query.contentList.result, function(key, item) { %>
                        <% if (item.typeOfRecord == 'KLEVU_CMS') { %>
                          <%= helper.render('contentBlock', scope, data, item) %>
                        <% }%>
                      <% }); %>
                    </ul>

                  <% } else { %>
                    <div class="klevu__no-results">
                      <span class="body-2">
                        <%= window.theme.strings.general.search.no_results_html %>
                      </span>
                    </div>
                  <% } %>
                </div>

                <div class="klevu__pagination">
                  <%=helper.render('klevuLandingTemplateInfiniteScrollDown', scope, data) %>
                  <%=helper.render('pagination', scope,data, 'contentList') %>
                </div>
              </div>

              <div data-block-id="ku_landing_other_items"></div>
              <footer data-block-id="ku_landing_result_footer"></footer>
            </section>

            <section
              data-container-id="ku_landing_main_content_right"
              data-container-position="right"
              data-container-role="right"
            >
              <div data-block-id="ku_landing_right_facets"></div>
              <div data-block-id="ku_landing_right_call_outs"></div>
              <div data-block-id="ku_landing_right_banner"></div>
            </section>
          </div>
        </div>
      </div>
    </div>
  <% } %>
</div>`;

/**
 * Filter tags template.
 * - Active filters template.
 */
var templateFilterTags = `
<%
  var filterTagsModule = data.filterTags;
  var filterTagsData = [];

  if (dataLocal && dataLocal.length) {
    filterTagsData = filterTagsModule.query[dataLocal].tags;
  }
%>

<% if (filterTagsData.length) { %>
  <div class="klevu-active-filters kuFilterTagsContainer">
    <% helper.each(filterTagsData, function(key,item) {
      var filterTagItemKey = helper.escapeHTML(item.key);
      var filterTagItemLabel = helper.escapeHTML(helper.translate(item.label));
    %>
      <span
        class="
          klevu-active-filters__type
          kuFilterTag
          <%= (filterTagItemKey?.toLowerCase() === 'colour') ? 'has-swatches' : '' %>
        "
        data-key="<%= filterTagItemKey %>"
        data-type="<%= helper.escapeHTML(item.type) %>"
      >
        <span
          class="klevu-active-filters__type-name kuFilterTagKey"
          title="<%= filterTagItemLabel %>"
          data-value="<%= filterTagItemLabel %>"
        >
          <%= helper.translate(item.label) %>
        </span>

        <% helper.each(item.values, function(key, option) { %>
          <%
            var optionLabel = helper.translate(option);

            if (optionLabel.includes(' - ')) {
              var parts = optionLabel.split(' - ');

              var optionLabel = parts.map((part) => {
                return window.theme.moneyFormat.replace('{{amount}}', part)
              }).join(' - ');
            }
          %>

          <% if (item.type === "RATING") { %>
            <button
              class="
                klevu-active-filters__tag
                body-2
                kuFilterTagValue
              "
              title="<%= helper.escapeHTML(optionLabel) %>"
              type="button"
              data-value="<%= helper.escapeHTML(helper.translate(option)) %>"
            >
              <div class="klevuFacetStars">
                <div
                  class="klevuFacetRating"
                  style="width: <%= (20*Number(option)) %>%;"
                ></div>
              </div>

              <%= window.theme.icon.close %>
            </button>

          <% } else { %>
            <button
              class="
                klevu-active-filters__tag
                body-2
                kuFilterTagValue
              "
              title="<%= helper.escapeHTML(optionLabel) %>"
              type="button"
              data-value="<%= helper.escapeHTML(helper.translate(option)) %>"
              js-klevu-filters="active"
            >
              <span
                class="klevu-filters__swatch"
                data-color-swatch="<%= helper.escapeHTML(helper.translate(option))?.toLowerCase() %>"
              ></span>

              <%= optionLabel %>
              <%= window.theme.icon.close %>
            </button>
          <% } %>
        <% }); %>
      </span>
    <% }); %>

    <button
      class="klevu-active-filters__clear-all kuFilterTagClearAll"
      title="<%= window.theme.strings.collection.filters.clear_all %>"
      type="button"
    >
      <%= window.theme.strings.collection.filters.clear_all %>
    </button>
  </div>

<% } else if (!filterTagsData.length && !helper.hasResults(data, 'productList')) { %>
  <div class="klevu-active-filters">
    <span class="klevu-active-filters__type">
      <button
        class="
          klevu-active-filters__tag
          body-2
          kuFilterTagClearAll
        "
        type="button"
      >
        <%= window.theme.strings.collection.filters.clear_all %>
        <%= window.theme.icon.close %>
      </button>
    </span>
  </div>
<% } %>`;

/**
 * Sort by.
 */
var templateSortBy = `
<div class="klevu__sorting">
  <div class="klevu__total-products caption">
    <%= window.theme.strings.collection.header.products.replace('{{ count }}', data.query['productList']?.meta.totalResultsFound) %>
  </div>

  <div
    class="klevu__sort-by kuDropdown kuDropSortBy"
    role="listbox"
    tabindex="0"
  >
    <div class="klevu__sort-by-label kuDropdownLabel">
      <span class="klevu__sort-by-text caption">
        <%= window.theme.strings.collection.header.sort_by %> <%= helper.translate(helper.getSortByCustom(dataLocal)) %>
      </span>

      <%= window.theme.icon.chevronDown %>
    </div>

    <div class="klevu__sort-by-options kuDropdownOptions">
      <div
        class="kuDropOption kuSort"
        role="option"
        data-value="RELEVANCE"
      >
        <%= window.theme.strings.collection.sorting.relevance %>
      </div>

      <div
        class="kuDropOption kuSort"
        role="option"
        data-value="PRICE_ASC"
      >
        <%= window.theme.strings.collection.sorting.price_asc %>
      </div>

      <div
        class="kuDropOption kuSort"
        role="option"
        data-value="PRICE_DESC"
      >
        <%= window.theme.strings.collection.sorting.price_desc %>
      </div>

      <div
        class="kuDropOption kuSort"
        role="option"
        data-value="NAME_ASC"
      >
        <%= window.theme.strings.collection.sorting.name_asc %>
      </div>

      <div
        class="kuDropOption kuSort"
        role="option"
        data-value="NAME_DESC"
      >
        <%= window.theme.strings.collection.sorting.name_desc %>
      </div>

      <div
        class="kuDropOption kuSort"
        role="option"
        data-value="NEW_ARRIVAL_ASC"
      >
        <%= window.theme.strings.collection.sorting.new_arrival_asc %>
      </div>

      <div
        class="kuDropOption kuSort"
        role="option"
        data-value="NEW_ARRIVAL_DESC"
      >
        <%= window.theme.strings.collection.sorting.new_arrival_desc %>
      </div>
    </div>
  </div>
</div>`;

/**
 * Tab results/search results.
 */
var templateTabResults = `
<% if (data.settings.term !== '*') { %>
  <% var count = data.query?.contentList?.meta?.totalResultsFound + data.query?.productList?.meta?.totalResultsFound %>
  <% document.title = window.theme.strings.general.search.page_title.replace('{{ count }}', count).replace('{{ terms }}', data.settings.term).replace('{{ shop_name }}', window.theme.name) %>

  <div class="klevu-search__header">
    <h1 class="klevu-search__title body-2">
      <%= window.theme.strings.general.search.results_with_count.other.replace('{{ count }}', count) %>
    </h1>

    <p class="klevu-search__term h1">
      <%= data.settings.term %>
    </p>
  </div>

  <div
    class="klevu-search__tabs"
    role="tablist"
  >
    <% var selectedTab = false; %>

    <% helper.each(data.query,function(key,query) { %>
      <% if (query.tab == true) { %>
        <% if (helper.hasResults(data, query.id) || helper.hasFilters(data, query.id)) { %>
          <a
            class="
              klevu-search__tab
              <% if (!selectedTab) { selectedTab = true; %>is-active<% } %>
            "
            area-label="Products tab"
            role="tab"
            tabindex="0"
            target="_self"
            aria-selected=''
            data-section="<%= query.id %>"
            js-search="tab"
          >
            <% if (query.id === 'productList') { %>
              <% var label = window.theme.strings.general.search.products_tab %>
            <% } else { %>
              <% var label = window.theme.strings.general.search.pages_tab %>
            <% } %>

            <% var label = label.replace('{{ count }}', data.query[query.id].meta.totalResultsFound) %>
            <%= label %>
          </a>

        <% } else { %>
          <a
            class="klevu-search__tab"
            area-label="Products tab"
            disabled
            role="tab"
            tabindex="0"
            target="_self"
            aria-selected=''
            data-section="<%= query.id %>"
            js-search="tab"
          >
            <% if (query.id === 'productList') { %>
              <% var label = window.theme.strings.general.search.products_tab %>
            <% } else { %>
              <% var label = window.theme.strings.general.search.pages_tab %>
            <% } %>

            <% var label = label.replace('{{ count }}', 0) %>
            <%= label %>
          </a>
        <% } %>
      <% } %>
    <% }); %>
  </div>
<% } %>`;

/**
 * Content block/page template.
 */
var templateContentBlock = `
<%
  var updatedProductName = dataLocal.name;

  if (klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
    if (klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
      updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
    }
  }

  var hasImageFound = dataLocal.image && dataLocal.image !== '';

  if (!hasImageFound) {
    hasImageFound = dataLocal.imageUrl && dataLocal.imageUrl !== ''
  }
%>

<li
  class="klevu-content"
  data-id="<%= dataLocal.id %>"
>
  <a
    class="klevu-content__container"
    href="<%= dataLocal.url %>"
    title="<%= updatedProductName %>"
    target="_self"
  >
    <div
      class="
        klevu-content__image-container
        <% if (!hasImageFound) { %>
          klevu-content__image-container--no-image
        <% } %>
      "
    >
      <% if (hasImageFound) { %>
        <img
          class="klevu-content__image"
          alt="<%= updatedProductName %>"
          loading="lazy"
          sizes="auto"
          src="<%= dataLocal.image.replace('_medium', '') %>&width=1000"
          srcset="
            <%= dataLocal.image.replace('_medium', '') %>&width=200 200w,
            <%= dataLocal.image.replace('_medium', '') %>&width=300 300w,
            <%= dataLocal.image.replace('_medium', '') %>&width=400 400w,
            <%= dataLocal.image.replace('_medium', '') %>&width=500 500w,
            <%= dataLocal.image.replace('_medium', '') %>&width=600 600w,
            <%= dataLocal.image.replace('_medium', '') %>&width=700 700w,
            <%= dataLocal.image.replace('_medium', '') %>&width=800 800w,
            <%= dataLocal.image.replace('_medium', '') %>&width=900 900w
          "
        >
      <% } %>
    </div>

    <div
      class="klevu-content__meta"
      data-block-id="ku_landing_result_item_footer"
    >
      <p class="klevu-content__title subtitle-2">
        <%= updatedProductName %>
      </p>

      <% if (dataLocal.shortDesc) { %>
        <p class="body-2">
          <%= dataLocal.shortDesc.replace('---RECIPE---', '') %>...
        </p>
      <% } %>
    </div>
  </a>
</li>`;
